import { render, staticRenderFns } from "./BlankFileView.vue?vue&type=template&id=38a2f59f&"
import script from "./BlankFileView.vue?vue&type=script&lang=js&"
export * from "./BlankFileView.vue?vue&type=script&lang=js&"
import style0 from "./BlankFileView.vue?vue&type=style&index=0&id=38a2f59f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports